import React from "react";
import { GetPrefixUniversity } from "../MainApp";
import Properties from "../component/Properties";
import moment from "moment";

export const AppSetting = () => {
    const universityPrefix = GetPrefixUniversity();
    const AppSetting = JSON.parse(window.localStorage.getItem(`${universityPrefix}_CpanelAppsettings`));
    return AppSetting
}



//ClientSide user role weight
export const ADMIN_USER_ROLE = 2;

// REFACTORED FROM category.js state:mode
export const SUBCATEGORY_STATE_MODE = 0
export const QUESTION_STATE_MODE = 1
export const EXPLANATIONS_STATE_MODE = 2


/* 
    DO NOT use arrow function as a constructor (Used in PerfData.js line 32 )
    Eg: https://jsfiddle.net/praveeen/L3e7ucaf/2/
*/
export function AppProperties() {
    const appProperties = new Properties() ;
    return appProperties;
}

export const GetAppURL = () => {
	let AppURL = window.location.protocol + "//" + window.location.hostname;
	let PORT = 8095;
	let defaultGOPathName = "/goapi";
	let hostName;
	if (window.location.hostname === 'localhost') {
		AppURL = window.location.protocol + "//" + window.location.hostname + ":" + PORT;
	} else {
		if (window.location.hostname.includes("essentialskills")) {
			hostName = "essentialskills.osu.edu/lti"
		  } else if (window.location.hostname.includes("phy-essential-p")) {
			hostName = "phy-essential-p.asc.ohio-state.edu/lti"
		  } else if (window.location.hostname.includes("phy-essential-s")) {
			hostName = "phy-essential-s.asc.ohio-state.edu/lti"
		  } else {
			let hostArray = window.location.hostname.split(".");
	
			if (hostArray.length > 4) {
				hostName = `${hostArray[hostArray.length - 3]}.${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/${hostArray[hostArray.length - 5]}`;
			} else if (hostArray.length == 4) {
				hostName = `${hostArray[hostArray.length - 2]}.${hostArray[hostArray.length - 1]}/${hostArray[hostArray.length - 4]}`;
			}
		}
		AppURL = window.location.protocol + "//" + hostName + defaultGOPathName;
	}
	return AppURL;
}

// input format dd/mm/yyyy , ss:mm:hh
export function getUtcTimestamp(dateString, timeString) {
	var parts1 = dateString.split('/');
	var parts2 = timeString.split(':');
	var day = parseInt(parts1[0], 10);
	var month = parseInt(parts1[1], 10) - 1;
	var year = parseInt(parts1[2], 10);
	var hour = parseInt(parts2[0], 10);
	var minute = parseInt(parts2[1], 10);
	var second = parseInt(parts2[2], 10);
	var dateObj = new Date(Date.UTC(year, month, day, hour, minute, second));
	return dateObj.getTime();
  }

export const PronounList = [
	{
	  label: "he/him/his",
	  value: 1,
	},
	{
	  label: "she/her/hers",
	  value: 2,
	},
	{
	  label: "they/them/their",
	  value: 3,
	},
	{
	  label: "prefer not to say",
	  value: 4,
	},
	{
	  label: "ask me about my pronouns",
	  value: 5,
	},
	{
	  label: "other pronouns/not listed",
	  value: 6,
	}
	,
	{
	  label: "none",
	  value: 7,
	}	
]

const timeZoneToLocale = {
	// Eastern Time
	"America/New_York": "en-US",    // Eastern Standard Time (EST)
	"America/Detroit": "en-US",      // Eastern Standard Time (EST)
	"America/Toronto": "en-CA",      // Eastern Standard Time (EST) - Canada
	"America/Indiana/Indianapolis": "en-US", // Eastern Standard Time (EST) - Indiana
  
	// Central Time
	"America/Chicago": "en-US",      // Central Standard Time (CST)
	"America/Winnipeg": "en-CA",     // Central Standard Time (CST) - Canada
	"America/Mexico_City": "es-MX",  // Central Standard Time (CST) - Mexico
  
	// Mountain Time
	"America/Denver": "en-US",       // Mountain Standard Time (MST)
	"America/Phoenix": "en-US",      // Mountain Standard Time (MST) - Arizona (no DST)
  
	// Pacific Time
	"America/Los_Angeles": "en-US",  // Pacific Standard Time (PST)
	"America/Vancouver": "en-CA",    // Pacific Standard Time (PST) - Canada
  
	// Indian Standard Time
	"Asia/Kolkata": "en-IN",         // Indian Standard Time (IST)
  
  };

export const getDateFormat = (dateStr, timeZone) => {

	console.debug("dateStr", dateStr)

	const appProperties = AppProperties();
	
	if (!timeZone) {
		if (appProperties && appProperties.currentUserData && appProperties.currentUserData.timeZone) {
			timeZone = appProperties.currentUserData.timeZone;
		}
	}

	if (!dateStr || !timeZone) {
	  console.warn("Date or Timezone is invalid", dateStr, timeZone);
	  return "";
	}
	
	let date = moment.tz(dateStr, timeZone);
  
	let dateInTimeZone = date.toDate();
  
	let locale = timeZoneToLocale[timeZone] || 'default';
  
	let formattedDate = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        // second: 'numeric',
        hour12: true,
    }).format(dateInTimeZone);
  
	return formattedDate;
  }

  export const IsEmailValid = (emailAddress) => {
	const appProperties = AppProperties();

	const mailDomain = appProperties.mailDomain;
	const emailFormatRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	if (emailAddress === "" || !emailFormatRegex.test(emailAddress)) {
		return "Invalid email"
	}

	const [, domain] = emailAddress.split('@');

	if (appProperties.mailDomain !== "any" && !mailDomain.includes(domain)) {
		return `Mail domain is not valid. Please use ${appProperties.mailDomain.replace(";", ", ")}`
	}

	return ""
}